/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_Template_HintInputs */

const cs_settings_office_template_hint = /** @type {(inputs: Settings_Office_Template_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vzhled veřejného webu kanceláře. Barvu určuje pole Barva kanceláře výše.`)
};

const en_settings_office_template_hint = /** @type {(inputs: Settings_Office_Template_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Look of the office's public website. Colour is set by the Office accent colour field above.`)
};

/**
* | output |
* | --- |
* | "Look of the office's public website. Colour is set by the Office accent colour field above." |
*
* @param {Settings_Office_Template_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_template_hint = /** @type {((inputs?: Settings_Office_Template_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_Template_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_template_hint(inputs)
	return cs_settings_office_template_hint(inputs)
});